import React from "react";
import { useTourPageContext } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import { Accommodations } from "../accommodations";
import { Equipment } from "../equipment/Equipment";
import { Faq } from "../faq";
import { Flights } from "../flights";
import { Itinerary } from "../itinerary";
import { MarketingTextCard } from "../marketing-text-card";
import { MessageTextCard } from "../message-text-card";
import { Overview } from "../overview";
import { Reviews } from "../reviews";
import { TravelerPhotos } from "../traveler-photos";
import { Weather } from "../weather";

export const TourSections: React.FC = () => {
    const { pageConfig } = useTourPageContext();
    const marketingContent = pageConfig.tourPageMarketing?.content;

    const customizedSectionOrder = pageConfig.tourPageSectionOrder.map(
        (sectionBlok) => sectionBlok.section as TourSectionId,
    );

    const sectionComponentMap: Record<TourSectionId, React.JSX.Element> = {
        [TourSectionId.OVERVIEW]: <Overview />,
        [TourSectionId.ITINERARY]: <Itinerary />,
        [TourSectionId.ACCOMMODATIONS]: <Accommodations />,
        [TourSectionId.EQUIPMENT]: <Equipment />,
        [TourSectionId.FLIGHTS]: <Flights />,
        [TourSectionId.REVIEWS]: <Reviews />,
        [TourSectionId.FAQ]: <Faq />,
        [TourSectionId.PHOTOS]: <TravelerPhotos />,
        [TourSectionId.PRIMARY_MESSAGE]: (
            <MessageTextCard cards={marketingContent?.primaryMessage ?? []} />
        ),
        [TourSectionId.SECONDARY_MESSAGE]: (
            <MarketingTextCard
                cards={marketingContent?.secondaryMessage ?? []}
            />
        ),
        [TourSectionId.TERTIARY_MESSAGE]: (
            <MarketingTextCard
                cards={marketingContent?.tertiaryMessage ?? []}
            />
        ),
        [TourSectionId.WEATHER]: <Weather />,
    };

    const validSections = [TourSectionId.PRIMARY_MESSAGE].concat(
        customizedSectionOrder,
    );

    return (
        <>
            {validSections.map((section) => (
                <React.Fragment key={section}>
                    {sectionComponentMap[section]}
                </React.Fragment>
            ))}
        </>
    );
};
